import React from "react";
import styles from "./InventoryColumn2.module.css";
import { QuantityBadge } from "../../../components/QuantityBadge";
import { ResultEntry } from "../../../types/data";
import { EanQuantityBundle } from "../../../components/EanQuantityBundle";
import { EANView } from "../../../components/EANView";

interface Props {
  title: string;
  items: ResultEntry[];
  databaseItems: ResultEntry[];
  newItems: ResultEntry[];
  onItemClick: (ean: string, qty: string) => void;
  badgeStatus?: (item: ResultEntry) => "plus" | "minus" | "neutral";
  children?: React.ReactNode;
  isLoading?: boolean;
}

export const InventoryColumn2 = ({
  title,
  items,
  databaseItems,
  newItems,
  onItemClick,
  badgeStatus,
  children,
  isLoading = false
}: Props) => {
  const skeletonRows = Array.from({ length: 2 }, (_, i) => i);
  const hasItems = items.length > 0;
  const shouldShowContainer = isLoading || hasItems;

  return (
    <div className={styles.column}>
      <div className={styles.title}>{title}</div>
      {shouldShowContainer ? (
        <div className={styles.bundleContainer}>
          {isLoading
            ? skeletonRows.map((key) => (
                <EanQuantityBundle isLoading key={key}>
                  <span>0000</span>
                  <QuantityBadge>{0}</QuantityBadge>
                </EanQuantityBundle>
              ))
            : items.map((item) => {
                const existsInDatabase = databaseItems.some((dbItem) => dbItem.ean === item.ean);
                const existsInNew = newItems.some((newItem) => newItem.ean === item.ean);

                let eanStatus = "";
                if (existsInDatabase && !existsInNew) {
                  eanStatus = `${styles.removed}`;
                } else if (!existsInDatabase && existsInNew) {
                  eanStatus = `${styles.added}`;
                }

                let quantityStatus = "neutral";
                let old = databaseItems.find((o) => o.ean === item.ean);
                if (!old || item.quantity > old.quantity) quantityStatus = "plus";
                else if ((existsInDatabase && !existsInNew) || item.quantity < old.quantity) quantityStatus = "minus";

                return (
                  <EanQuantityBundle
                    className={`${styles.bundle} ${eanStatus}`}
                    key={item.ean}
                    onClick={() => onItemClick(item.ean, String(item.quantity))}
                  >
                    <EANView ean={item.ean} />
                    <QuantityBadge status={quantityStatus as any}>{item.quantity}</QuantityBadge>
                  </EanQuantityBundle>
                );
              })}
        </div>
      ) : (
        <>Brak</>
      )}
      {children}
    </div>
  );
};
